import React from 'react';
import { injectIntl } from 'react-intl';

import Show from './Show';
import Edit from './Edit';

const NO_OP = () => {};

const QuantitativeAnswer = ({
  intl,
  value,
  previous_value,
  previous_comment,
  previous_attachments,
  comment,
  source,
  source_params,
  schema,
  edit,
  loading,
  onEdit = NO_OP,
  onSave = NO_OP,
  onClear = NO_OP,
  onCancel = NO_OP,
  onShowLastPeriod = NO_OP,
  onUseLastValue = NO_OP,
  onUseLastWholeData = NO_OP,
  onUseLastAttachments = NO_OP,
  onUseLastPeriod = NO_OP,
  canWrite = false,
  target,
  onTarget,
  suborganization_data,
  dependees,
  config,
}) => {
  const t = intl.messages;

  return (
    <React.Fragment>
      <section className='KpiDetail__answer'>
        <div style={{display:"flex", flexDirection:"row"}}>
        <div className="ant-col-6 KpiDetail__title">{ t.answer }</div>
        { target && 
          <div className="ant-col-6 KpiDetail__title">{t.createcustomkpi_target}</div>        
        }

        </div>

        {
          edit && canWrite
          ? <Edit
              source={source}
              source_params={source_params}
              schema={schema}
              value={value}
              comment={comment}
              onSave={onSave}
              onClear={onClear}
              onCancel={onCancel}
              previous_value={previous_value}
              previous_comment={previous_comment}
              previous_attachments={previous_attachments}
              onShowLastPeriod={onShowLastPeriod}
              onUseLastValue={onUseLastValue}
              onUseLastWholeData={onUseLastWholeData}
              onUseLastAttachments={onUseLastAttachments}
              onUseLastPeriod={onUseLastPeriod}
              target={target}
              onTarget={onTarget}
              config={config}
            />
          : <Show
              source={source}
              source_params={source_params}
              schema={schema}
              value={value}
              comment={comment}
              previous_value={previous_value}
              previous_comment={previous_comment}
              previous_attachments={previous_attachments}
              onEdit={onEdit}
              onShowLastPeriod={onShowLastPeriod}
              onUseLastValue={onUseLastValue}
              onUseLastWholeData={onUseLastWholeData}
              onUseLastAttachments={onUseLastAttachments}
              onUseLastPeriod={onUseLastPeriod}
              canWrite={canWrite}
              target={target}
              onTarget={onTarget}
              suborganization_data={suborganization_data}
              dependees={dependees}
              config={config}
            />
        }

      </section>
    </React.Fragment>
  );
}

QuantitativeAnswer.Show = Show.Component;
QuantitativeAnswer.Edit = Edit.Component;
QuantitativeAnswer.TableShow = Show.TableComponent;
QuantitativeAnswer.TableEdit = Edit.TableComponent;
QuantitativeAnswer.Summary = Show.SummaryComponent;

export default injectIntl(QuantitativeAnswer);
